import iso3Json from './iso3.json';

export function mapIso2ToIso3(data) {
  return (Object.keys(data)).map(k => ({ id: iso3Json[k], value: data[k] }));
}
